const lang = {
  pages: {
    home: 'ホーム',
    notice: 'お知らせ',
    account: 'アカウント'
  },
  button: {
    close_modal_success: '戻る',
    close_modal_error: 'OK'
  },
  header: {
    dropdown: {
      user_info: '利用者情報',
      logout: 'ログアウト',
      back: '戻る'
    }
  },
  footer: {
    copyright: '(c)2020 LECRE Inc.JAPAN. All Rights Reserved.'
  },
  sidebar: {
    notification: 'お知らせ',
    account: 'アカウント',
    contact_us: 'お問い合わせ',
    faq: 'よくある質問',
    term_service: '利用規約',
    privacy: '個人情報保護方針について',
    commercial_law: '特定商取引法に基づく表記',
    logout: 'ログアウト',
    other: 'その他',
    privacy_policy: '個人情報保護方針',
    company: '運営会社',
    guide: 'ガイド'
  },
  btn_save: '保存',
  btn_back: '戻る',
  btn_next: '次へ',
  btn_send: '送信する',
  btn_confirm: '設定',
  btn_ok: 'OK',
  btn_cancel: 'キャンセル',
  please_enter: '入力してください',
  please_enter_without_hyphen: '入力してください（ハイフンなし）',
  delete: '削除',
  switch: '並び替え',
  zengo: 'ゼ　ン　ゴ',
  network_error: 'ネットワークに接続できません。',
  server_error: 'サーバーに接続できません。',
  api_error: 'エラーが発生しました。サポートにお問い合わせください。code:{code}',
  page_title: 'ZENGO（ゼンゴ）｜ビルメン・不動産・リフォーム業向け写真報告書ソリューション'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/common.js